// extracted by mini-css-extract-plugin
export default {"authFormContainer":"login_authFormContainer__9N9J9","authForm":"login_authForm__pnuta"};